export enum AuthActionTypes {
  Login = '[Auth/Page] Login',

  RequireTwoFactorAuth = '[Auth/API] Require Two Factor Auth',
  TwoFactorAuth = '[Auth/Page] Two Factor Auth',

  Resend2faCode = '[Auth/Page] Resend Two Factor Auth Code',

  ForgotPassword = '[Auth/Page] Forgot Password',

  ForgotPasswordReset = '[Auth/Page] Forgot Password Reset',

  ResetPassword = '[Auth/Page] Reset Password',

  SetPassword = '[Auth/Page] Set Password',

  ChangePassword = '[Auth/Page] Change Password',
}

export enum AccountActionTypes {
  Init = '[Account Page] Init',
  Destroyed = '[Account Page] Destroyed',
  LanguageUpdated = '[Account Page] Language Updated',
}
